module.exports = __webpack_public_path__ + "static/media/survey.53fe3555.svg";